// helper to strongly type Object.keys
export function getKeys<T extends object>(obj: T): (keyof T)[] {
    return Object.keys(obj) as (keyof T)[];
}

// sort function
export function sortKeys<T>(keys: (keyof T)[], sortOrder: string): (keyof T)[] {
    const order = sortOrder.split(",").map(s => s.trim());
    return [...keys].sort((a, b) => {
        const ia = order.indexOf(a as string);
        const ib = order.indexOf(b as string);
        if (ia === -1 && ib === -1) return 0;
        if (ia === -1) return 1;
        if (ib === -1) return -1;
        return ia - ib;
    });
}

export function splitPascalCase(input: string): string {
  if (!input) return "";

  return input
    // insert space before each capital letter (except first)
    .replace(/([A-Z])/g, " $1")
    .trim()
    // normalise spacing
    .split(/\s+/)
    // capitalise each word
    .map(
      word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join(" ");
}

export function sortedProperties<T extends object>(
  displayObject: T | undefined,
  sortOrder: string
): { key: keyof T; value: T[keyof T] }[] {
  if (!displayObject) {
    return [];
  }

  const allKeys = getKeys(displayObject); // typed as (keyof T)[]
  const sortedKeys = sortKeys<T>(allKeys, sortOrder);

  return sortedKeys.map((key) => ({
    key,
    value: displayObject[key],
  }));
}